import React from "react";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll"; // Import Link untuk scroll
import "bootstrap/dist/js/bootstrap.bundle.min";

const Navbar = () => {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-light bg-light fixed-top"
      role="navigation"
      aria-label="main navigation"
    >
      <div className="container-fluid">
        {/* Link to scroll to the top */}
        <ScrollLink
          className="navbar-brand"
          to="Top"
          smooth={true}
          duration={500}
          offset={-70}
        >
          <img
            src="/static/logo_potrait.png"
            alt="Logo"
            style={{ maxHeight: "50px", width: "auto" }}
          />
        </ScrollLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {/* Home / Scroll to top */}
            <li className="nav-item">
              <ScrollLink
                className="nav-link"
                to="Top"
                smooth={true}
                duration={500}
                offset={-70}
              >
                Home
              </ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink
                className="nav-link"
                to="FeatureCards"
                smooth={true}
                duration={500}
                offset={-70}
              >
                Feature Cards
              </ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink
                className="nav-link"
                to="cekResiSection"
                smooth={true}
                duration={500}
                offset={-70}
              >
                Cek Resi
              </ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink
                className="nav-link"
                to="hasilProduksiSection"
                smooth={true}
                duration={500}
                offset={-70}
              >
                Hasil Produksi
              </ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink
                className="nav-link"
                to="aboutUsSection"
                smooth={true}
                duration={500}
                offset={-70}
              >
                About Us
              </ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink
                className="nav-link"
                to="sumberProduksiSection"
                smooth={true}
                duration={500}
                offset={-70}
              >
                Sumber Produksi
              </ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink
                className="nav-link"
                to="updatePengirimanSection"
                smooth={true}
                duration={500}
                offset={-70}
              >
                Update Pengiriman
              </ScrollLink>
            </li>

            <li className="nav-item">
              <Link className="btn btn-primary login-button" to="/login">
                Login
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
